import { productLike } from '@/shared/product-like/product-like';

export class ProductInfo {
	constructor(element) {
		this.element = element;
		if (!this.element) return;
		this.init();
	}

	init() {
		productLike(this.element, '.product-info__fav-button');
	}
}
